import {
  type ThemeName,
  DEFAULT_THEME,
  THEME_STORAGE_KEY,
  palettes,
  isValidTheme,
} from './themes'

export type { ThemeName }
export { DEFAULT_THEME, THEME_STORAGE_KEY, palettes, isValidTheme }

export function getStoredTheme(): ThemeName {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY)
    if (isValidTheme(raw)) return raw
  } catch {
    // localStorage may be unavailable (private mode, etc.)
  }
  return DEFAULT_THEME
}

export function setStoredTheme(name: ThemeName): void {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, name)
  } catch {
    // ignore
  }
}

export function applyTheme(name: ThemeName): void {
  const html = document.documentElement
  html.dataset.theme = name

  const palette = palettes[name]
  for (const [key, value] of Object.entries(palette)) {
    html.style.setProperty(key, value)
  }
}
